import React from "react";
import { Input } from "../../ui/input";
import QuestionFrame from "./QuestionFrame";

/**
 * Single-line text question.
 *
 * @param {Object} props
 * @param {object} props.question
 * @param {string} [props.value]
 * @param {function(string): void} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.readOnly]
 * @returns {JSX.Element}
 */
export default function ShortTextQuestion({ question, value = "", onChange, error, readOnly, showRequired }) {
  const fieldId = `survey-q-${question.id}`;
  return (
    <QuestionFrame question={question} error={error} showRequired={showRequired}>
      <Input
        id={fieldId}
        type={question.inputType === "email" ? "email" : "text"}
        autoComplete={question.inputType === "email" ? "email" : undefined}
        value={value || ""}
        placeholder={question.placeholder || ""}
        maxLength={question.maxLength || undefined}
        disabled={readOnly}
        className={error ? "border-error" : undefined}
        onChange={(e) => onChange(e.target.value)}
      />
    </QuestionFrame>
  );
}
